import type { CSSProperties } from 'react';
import { strings, type BlogLang } from '../lib/blog';
import { getStrings } from '../lib/i18n';
import { StoreBadges } from './StoreBadges';
import { STORE_IOS, STORE_ANDROID } from '../lib/constants';

export function CtaBlock({ lang }: { lang: BlogLang }) {
  const t = strings[lang];
  const s = getStrings(lang).store;
  return (
    <div className="mt-12 card-glow px-6 py-10 md:px-10 md:py-12 text-center" style={{ '--glow': 'var(--brand-2)' } as CSSProperties}>
      <h2 className="font-heading text-2xl md:text-3xl font-black text-white mb-3">{t.ctaHeading}</h2>
      <p className="text-white/80 mb-7 max-w-lg mx-auto">{t.ctaBody}</p>
      <div className="flex flex-wrap justify-center gap-3">
        <StoreBadges iosHref={STORE_IOS} androidHref={STORE_ANDROID} s={s} lang={lang} />
      </div>
    </div>
  );
}
